module.exports = __webpack_public_path__ + "img/1.8b0a8be6.png";